module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (193).9ee0a07b.jpg";